const styles = theme => ({
    label: {
        color: theme.palette.primary.main,
        fontSize: '1.1rem'
    },
    centeredMessage: {
        textAlign: 'center',
        overflow: 'hidden',
        fontWeight: 100,
        fontSize: 64,
        padding: theme.spacing(2),
        [theme.breakpoints.down('lg')]: {
            fontSize: '3rem',
            padding: theme.spacing(1)
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '2rem',
            padding: theme.spacing(1)
        }
    },
    strong: {
        fontWeight: '600 !important'
    },

    h1: {
        fontSize: 64,
        color: theme.palette.text.primary,
        [theme.breakpoints.down('md')]: {
            fontSize: 38,
        }
    },
    h2: {
        fontSize: 42,
        color: theme.palette.text.tertiary,
        fontWeight: 300,
        [theme.breakpoints.down('md')]: {
            fontSize: 36,
        }
    },
    h3: { fontSize: 34, color: theme.palette.text.primary, fontWeight: 100 },
    h4: { fontSize: 30, color: theme.palette.text.primary, fontWeight: 500 },
    h5: { fontSize: 24, color: theme.palette.text.primary },
    h6: { fontSize: 20, color: theme.palette.text.secondary, fontWeight: 600 },
    subtitle1: { fontSize: 20, color: theme.palette.text.primary, fontWeight: 600 },
    subtitle2: { fontSize: 14, color: theme.palette.text.secondary, fontWeight: 600 },
    textButton: { fontSize: 16, color: theme.palette.text.secondary },
    body1: { fontSize: 16, color: theme.palette.text.primary },
    body2: { fontSize: 14, color: theme.palette.text.primary },
    button: { fontSize: 14, color: theme.palette.text.primary },
    caption: { fontSize: 12, color: theme.palette.text.secondary },
    overline: { fontSize: 10, color: theme.palette.text.primary }
});

export default styles;